import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { useIsDesktop } from '../../../../../utils';
import SearchInput from './components/SearchInput';

function ViewersSection({ data = [] }) {
  console.log(data);
  const isDesktop = useIsDesktop();

  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState(data || []);

  useEffect(() => {
    const filtered = data.filter(item =>
      item.user?.username?.toLowerCase().includes(searchText?.toLowerCase())
      || item.user?.last_name?.toLowerCase().includes(searchText?.toLowerCase())
      || item.user?.first_name?.toLowerCase().includes(searchText?.toLowerCase()),
    );
    setFilteredData(filtered);
  }, [searchText]);
  const handleInputChange = (e) => {
    setSearchText(e.target.value);
  };
  const handleSubmit = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <Grid sx={{
      py: 2,
      px: 3,
      mb: 3,
      borderRadius: '8px',
      background: 'white',
      boxShadow: '0px 2px 20px 0px #00000012',
      width: isDesktop ? 'calc(50% - 5px)' : '100%',
    }}
    >
      <Box display="flex" width="100%" justifyContent="space-between" mb={5}>
        <Typography variant="h6" fontWeight="bold" fontSize={16}>
          مشاهده شده توسط (
          {data.length}
          {' '}
          نفر)
        </Typography>
      </Box>

      <Box display="flex flex-row" width="100%">
        <SearchInput onSubmit={handleSubmit} onChange={handleInputChange} />
        <TableContainer sx={{ maxHeight: '500px', overflowY: 'scroll' }}>
          <Table>
            <TableBody>
              {filteredData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ maxWidth: '40px' }}><img width="40px" height="40px" alt="avatar" src={item.user.avatar || 'data:image/png;base64,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'} style={{ borderRadius: '100px' }} /></TableCell>
                  <TableCell>
                    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{`${item.user.first_name} ${item.user.last_name}`}</span>
                    <br />
                    <span style={{ fontSize: '14px' }}>
                      @
                      {item.user.username}
                    </span>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'right', fontSize: '16px' }}>{dayjs(item.created_at).format(' hh:ss YYYY/MM/DD')}</TableCell>
                </TableRow>
              ))}

            </TableBody>
          </Table>

        </TableContainer>
      </Box>
    </Grid>
  );
}

export default ViewersSection;
